/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.pages

import japgolly.scalajs.react.extra.router.Path
import net.scalytica.blaargh.models.Article

object Views {

  trait ViewType {
    val basePath: String

    def basePath_NoPrefix = basePath.stripPrefix("#")
  }

  sealed trait View

  case object Home extends View with ViewType {
    override val basePath = ""
  }

  case object Gallery extends View with ViewType {
    override val basePath = "#gallery"
  }

  case object Publications extends View with ViewType {
    override val basePath = "#publications"
  }

  case object About extends View with ViewType {
    override val basePath = "#about"
  }

  case object NotFound extends View with ViewType {
    override val basePath = "#notfound"
  }

  case class Posts(ref: ArticleRef) extends View {
    def asPath: Path = Path(s"#${ref.navigationPath}")
  }

  object Posts extends ViewType {
    override val basePath = "#posts"
  }

  case class Filter(fc: FilterCriteria) extends View {
    def asPath: Path = Path(s"${Filter.basePath}/${fc.field}/${fc.value}")
  }

  object Filter extends ViewType {
    override val basePath = "#filter"
  }

  case class ArticleRef(date: String, filename: String) {
    def htmlFilePath = s"posts/$filename.html"

    def navigationPath = s"posts/$date/$filename"
  }

  case class FilterCriteria(field: String, value: String)

  object FilterCriteria {

    val GalleryFilter      = FilterCriteria("labels", Article.GalleryLabel)
    val PublicationsFilter = FilterCriteria("labels", Article.PublicationsLabel)
    val FairyCreaturesFilter =
      FilterCriteria("labels", Article.FairyCreaturesLabel)

  }

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/pages/Views.scala